let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2ROFE")).then(() => parcelRequire('1IV4d'));